import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { connect } from 'react-redux';
import _ from 'lodash';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { updateUserFilter } from '../actions';
import { selectFilterSingleValue, selectFilterValues, selectUserFilter } from '../selectors';
import { Dropdown } from '../../../components/Dropdown';
import { FormField } from '../../../components/FormFields';
import dayjs from 'dayjs';
import { normalizeSearchString } from '../../../utils/normalizeSearchString';
import { parseCompany } from '../../Companies/helpers';
import { companySearch } from '../../Companies/actions';
import { selectWork } from '../../Api/selectors';
import { REQUEST_COMPANIES_SEARCH } from '../../Companies/constants';
import { SearchSelect } from '../../../components/SearchSelectComponent';

const Container = styled.div`
  .ranged {
    min-width: ${props => (props.controlWidth ? props.controlWidth : '55%')};
  }

  min-width: ${props => (props.minWidth ? props.minWidth : '')};

  .button-filter-block {
    top: -50px;
    left: 0px;
  }
  .selected {
    background-color: #0183d5 !important;
    color: white !important;
  }
`;

const RightDecoratorFilter = styled.div`
  display: flex;
  background-color: red;
  !importantjustify-content: center;
  align-items: center;
  min-width: 100px;
  width: ${props => props.mobView && '100%'};
  height: 100%;
  padding: 6px;

  background-color: #cccccc;
  font-weight: 600;
  padding-left: 10px;
  font-size: 14px;
  color: #888888;
`;

const STATE = {
  selectedValues: [],
  selectedValue: null,
  selectedLabels: [],
  selectedLabel: '',
  altValue: null,
  showOptions: false,
  min: null,
  max: null,
  minDate: null,
  maxDate: null,
  text: '',
  company: null,
  user: null,
  searchLabel: '',
};

/* eslint-disable react/prefer-stateless-function */
class UserFilterComp extends BaseComponent {
  constructor(props) {
    let filterPair = props.filter?.properties?.find(f => f.key === props.name);
    let filterValue = filterPair?.value;
    let filterLabel = filterPair?.label;
    let updateState = {};
    if (filterValue) {
      switch (props.type) {
        case 'single':
          updateState = { selectedValue: filterValue[0] ?? null, selectedLabel: filterLabel[0] ?? '' };
          break;
        case 'multiple':
          updateState = { selectedValues: filterValue ?? [], selectedLabels: filterLabel ?? [] };
          break;
        case 'ranged':
          updateState = { min: filterValue[0] ?? '', max: filterValue[1] ?? '' };
          break;
        case 'ranged_date':
          updateState = {
            minDate: filterValue[0] ?? null,
            maxDate: filterValue[1] ?? null,
            selectedLabels: filterLabel ?? [],
          };
          break;
      }
    }

    super(props, {
      ...STATE,
      ...updateState,
      search: props.filter?.searchString || '',
    });

    this.wrapperRef = React.createRef();
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.props.altKey && prevState.selectedValue !== this.state.selectedValue) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        this.props.change(this.state.selectedValue, this.props.name, this.state.selectedLabel);
      }
    }
    if (this.props.altKey && prevState.altValue !== this.state.altValue) {
      if (this.state.altValue === null || this.state.altValue === '') {
        this.props.reset(true);
      } else {
        this.props.change(this.state.altValue, this.props.altKey);
      }
    }
    if (prevState.selectedValue !== this.state.selectedValue && !this.props.altKey) {
      if (this.state.selectedValue === null || this.state.selectedValue === '') {
        this.props.reset();
      } else {
        if (this.props.namedFilter) {
          this.props.changeValuesByName('status', this.state.selectedValue);
        }
        // this.props.changeValues([this.state.selectedValue + ''], [this.state.selectedLabel]);
      }
    }
    if (!_.isEqual(prevState.selectedValues, this.state.selectedValues)) {
      if (!this.state.selectedValues.length) {
        this.props.reset();
      } else {
        this.props.changeValues(this.state.selectedValues, this.state.selectedLabels);
      }
    }

    if (prevState[this.props.search] !== this.state[this.props.search]) {
      this.props.changeValues([this.state[this.props.search] + ''], [this.state.searchLabel]);
    }
  }

  reset() {
    this.setState({ ...STATE });
  }

  compareLabel = (a, b) => {
    if (a.label < b.label) {
      return -1;
    }
    if (a.label > b.label) {
      return 1;
    }
    return 0;
  };

  get options() {
    if (this.props.noModify && this.props.options?.length) {
      return this.props.options?.map(o => ({ label: o?.label, value: o?.value + '' }))?.sort(this.compareLabel);
    }
    const res = !!this.props.isBool ? [] : [{ label: `${this.lblStr('vehicle.filter.empty')}`, value: '-' }];
    const optionsToParse = this.props.isBool
      ? ['no', 'yes']
      : this.props.search
      ? []
      : this.props.options?.sort((a, b) => {
          if (a < b) {
            return -1;
          } else if (a > b) {
            return 1;
          } else return 0;
        });
    return res.concat(
      optionsToParse
        ?.map(value => {
          const lbl = this.lblStr(`vehicle.filter.${value}`) ?? '';
          return {
            label: `${lbl}` ?? value,
            value: this.props.isBool ? (value === 'yes' ? '1' : value === 'no' ? '0' : null) : value,
          };
        })
        ?.sort(() => this.compareLabel),
    );
  }

  get multiOptions() {
    if (this.props.noModify) return this.props.options?.sort(this.compareLabel);
    if (this.props.name === 'status') {
      return this.props.options?.map((option, code) => ({ label: option, value: code + '' }))?.sort(this.compareLabel);
    }
    if (this.state.text) {
      return this.props.options
        ?.filter(option => option?.toLowerCase()?.includes(this.state.text.toLowerCase()))
        ?.map(option => ({ label: option, value: option.toLowerCase() }))
        ?.sort(this.compareLabel);
    }
    return [{ label: `${this.lblStr('vehicle.filter.empty')}`, value: '-' }].concat(
      this.props.options
        ?.map(option => {
          return { label: this.lblStr(`${option}`), value: option.toLowerCase() };
        })
        ?.sort(this.compareLabel),
    );
  }

  get value() {
    return this.options.find(o => o.value === this.props.filterSingleValue);
  }

  toggleAltFilters = value => {
    if (value == 1) {
      this.setState({ selectedValue: '1', altValue: '0', selectedLabel: 'yes' });
    } else if (value == 0) {
      this.setState({ selectedValue: '0', altValue: '1', selectedLabel: 'no' });
    } else if (value == null) {
      this.setState({ selectedValue: '0', altValue: '0', selectedLabel: '' });
    }
  };

  renderSingleFilter = () => {
    const handleChange = pair => {
      console.log(pair);
      return pair.value === null
        ? this.props.setState({ selectedValue: null, selectedLabel: '' })
        : this.props.altKey && this.props.isBool
        ? this.toggleAltFilters(pair.value)
        : this.setState({ selectedValue: pair.value, selectedLabel: pair.label });
    };
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.label[0];
    if (this.props.namedFilter) {
      selected = this.props.filter?.status;
    }

    return (
      <SearchSelect
        minWidth={'100%'}
        maxWidth={'100%'}
        placeholder={this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`)}
        options={this.options}
        value={selected && { label: selected }}
        onChange={handleChange}
        className="filter"
      />
    );
  };

  toggleOption = (value, label, option) => {
    this.setState(state => {
      if (option == 'buttonFilter') {
        return {
          selectedValues: state.selectedValues.includes(value)
            ? state.selectedValues.filter(v => v !== value)
            : [...state.selectedValues, value],
          selectedLabels: state.selectedLabels.includes(label)
            ? state.selectedLabels.filter(l => l !== label)
            : [...state.selectedLabels, label],
        };
      }

      return {
        selectedValues: [...value],
        selectedLabels: [...label],
      };
    });
  };

  handleMultiselectSearch = e => {
    this.setState({ text: e.target.value, showOptions: !!e.target.value?.length });
  };

  renderMultipleFilter = () => {
    let isActiveButton = false;
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name);
    let selectedResult = [];

    selected?.value?.map((val, index) => {
      selectedResult?.push({
        value: val,
        label: selected?.label[index],
      });
    });

    return (
      <FormField>
        <SearchSelect
          isMulti
          closeMenuOnSelect={false}
          minWidth={'100%'}
          maxWidth={'100%'}
          value={selectedResult}
          onChange={e => {
            const values = e.map(item => item.value);
            const labels = e.map(item => item.label);
            this.toggleOption(values, labels);
          }}
          placeholder={label}
          options={this.multiOptions}
        />
      </FormField>
    );
  };

  searchCompany = () => {
    const searchText = normalizeSearchString(this.state.text);
    if (!searchText) return;
    this.props.searchCompany(this.state.text, result =>
      this.setState({
        showOptions: true,
        options: result?.items
          ?.map(parseCompany)
          ?.filter(company => {
            let filtered =
              (company.id !== this.state.company?.id && company?.__search?.indexOf(searchText) > -1) ||
              company.__email_search.indexOf(searchText) > -1;

            if (this.props.changeLocation) {
              filtered = company.__search.indexOf(searchText) > -1 || company.__email_search.indexOf(searchText) > -1;
            }

            return filtered;
          })
          ?.map(c => ({
            label: c.company_type === 'company' ? c?.name : `${c?.name}${c?.surname ? ' ' + c?.surname : ''}`,
            value: c?.id + '',
          })),
      }),
    );
  };

  search = () => {
    this._t = this.timeout(this.searchCompany, 600, this._t);
  };

  selectSearchOption = option => {
    this.setState({ [this.props.search]: option?.value, searchLabel: option?.label, text: '', showOptions: false });
  };

  onStringChange = evt => {
    let text = evt;
    this.setState({ text });
    let debounced = _.debounce(this.search, 300, { maxWait: 1000 });
    debounced();
  };

  renderMultiSearchFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.${this.props.name}`);
    if (this.props.search === 'company') {
      let selected = this.props.filter.properties?.find(p => p.key === this.props.name);
      let selectedResult = [];

      selected?.value?.map((val, index) => {
        selectedResult?.push({
          value: val,
          label: selected?.label[index],
        });
      });
      return (
        <SearchSelect
          isMulti
          isLoading={this.props.searching}
          onInputChange={this.onStringChange}
          closeMenuOnSelect={false}
          minWidth={'100%'}
          maxWidth={'100%'}
          value={selectedResult}
          onChange={e => {
            const values = e.map(item => item.value);
            const labels = e.map(item => item.label);
            this.toggleOption(values, labels);
          }}
          placeholder={label}
          options={this.state.options ?? []}
        />
      );
    }
  };

  renderYearFilter = () => {
    const label = this.props.label ?? this.lblStr(`vehicle.filter.right_decor.${this.props.name}`);
    const lastYear = new Date().getFullYear();
    let years = [];
    for (let i = lastYear; i >= 2005; i--) {
      years.push(i);
    }
    const minOptions = years.map(year => ({ label: year + '', value: `01-01-${year}` }));
    minOptions.push({ label: '< 2005', value: '01-01-1970' });
    const maxOptions = years.map(year => ({ label: year + '', value: `31-12-${year}` }));
    maxOptions.push({ label: '< 2005', value: '31-12-2004' });
    let selected = this.props.filter.properties?.find(p => p.key === this.props.name)?.value ?? [];
    let selLbl = this.props.filter.properties?.find(p => p.key === this.props.name)?.label ?? [];
    let min = selected?.length ? selected[0] : '';
    let max = selected?.length ? selected[1] : '';

    let minLabel = min === '0' ? 'from' : min;
    let maxLabel = max === '200000' ? 'to' : max;

    const setMinDate = item => this.setState({ minDate: item?.value, selectedLabels: [item?.label, selLbl[1] ?? ''] });
    const setMaxDate = item => this.setState({ maxDate: item?.value, selectedLabels: [selLbl[0] ?? '', item?.label] });
    return (
      <FormField>
        <HBox left vCenter flip={window.innerWidth <= 500}>
          <RightDecoratorFilter mobView={window.innerWidth <= 500}>{label}</RightDecoratorFilter>
          <Dropdown
            name="min"
            placeholder={this.lblStr('vehicle.filter.from')}
            options={minOptions}
            value={minLabel && { label: min !== '0' ? dayjs(minLabel).format('YYYY') : 'from' }}
            onChange={setMinDate}
            className="ranged"
          />
          <Dropdown
            name="max"
            placeholder={this.lblStr('vehicle.filter.to')}
            options={maxOptions}
            value={maxLabel && { label: max !== '200000' ? dayjs(maxLabel, 'YYYY').format('YYYY') : 'to' }}
            onChange={setMaxDate}
            className="ranged"
          />
        </HBox>
      </FormField>
    );
  };

  handleClickOutside = e => {
    if (!!this.wrapperRef && !this.wrapperRef?.current?.contains(e.target) && !!this.state.showOptions) {
      this.setState({ showOptions: false });
    }
  };

  render() {
    return (
      // <Container minWidth={this.props.minWidth} controlWidth={this.props.controlWidth}>
      //   {this.props.type === 'single' && !this.props.search && this.renderSingleFilter()}
      //   {this.props.type === 'multiple' && this.props.search && this.renderMultiSearchFilter()}
      // </Container>
      <div>
        {this.props.type === 'single' && !this.props.search && this.renderSingleFilter()}
        {this.props.type === 'multiple' && this.props.search && this.renderMultiSearchFilter()}
      </div>
    );
  }
}

UserFilterComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
  type: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  value: PropTypes.any,
  onChange: PropTypes.func,
  options: PropTypes.array,
  label: PropTypes.string,
  isBool: PropTypes.bool,
  altKey: PropTypes.string,
};

const mapStateToProps = (state, ownProps) =>
  createStructuredSelector({
    filter: selectUserFilter(),
    filterSingleValue: selectFilterSingleValue(ownProps.name),
    values: selectFilterValues(ownProps.name),
    searching: selectWork(REQUEST_COMPANIES_SEARCH),
  });

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
    reset(alt = false) {
      dispatch(
        updateUserFilter(null, {
          reset: alt ? ownProps.altKey : ownProps.name,
        }),
      );
    },
    changeValuesByName(name, value) {
      dispatch(
        updateUserFilter(null, {
          value,

          name,
        }),
      );
    },
    changeValues(values, labels = []) {
      dispatch(
        updateUserFilter({
          key: ownProps.name,
          value: values,
          label: labels,
          type: ownProps.type,
        }),
      );
    },
    change(value, key, label = '') {
      dispatch(
        updateUserFilter({
          key: key,
          value: [value.toString().toLowerCase()],
          label: [label],
          type: ownProps.type,
        }),
      );
    },
    searchCompany(text, callback) {
      dispatch(companySearch(text, callback));
    },
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const UserFilter = compose(withConnect, withRouter, injectIntl)(UserFilterComp);
